import React from 'react';
//material
import {Card, CardContent, withStyles, Grid, IconButton} from '@material-ui/core';
import {Phone, Email, Facebook, LinkedIn, Twitter } from '@material-ui/icons';
//styles
import styles from './group-leaders-styles';
//components
import Avatar from '../../avatar';

const GroupLeadersView = (props) => {
  const {classes, keyMembers} = props;
  return (
    <Card className={classes.card}>
      <CardContent className={classes.cardContent}>
        <div className={classes.title}>
          Group Leaders
        </div>

        <Grid container spacing={2}>
          {
            keyMembers.map((member, i) =>
            <Grid key={i} item xs={12} md={6} className={classes.leader}>
              <Avatar
                className={classes.avatar}
                size={130}
                src={member.photoUrl}
                alt={member.name}/>

              <div className={classes.textContainer}>
                <div className={classes.name}>{member.name}</div>
                <div className={classes.subheader}>{member.memberType.description}</div>

                {
                  member.phoneNumber &&
                    <div className={classes.contactDetails}><Phone className={classes.icon}/><a href={'tel:' + member.phoneNumber}>{member.phoneNumber}</a></div>
                }

                {
                  member.emailAddress &&
                    <div className={classes.contactDetails}><Email className={classes.icon}/><a href={'mailto:' + member.emailAddress}>{member.emailAddress}</a></div>
                }
              </div>

              <div className={classes.socialIcons}>
                <IconButton
                  classes={{ root: classes.iconButton + ' ' + classes.facebookButton }}
                  disabled={!member.facebookUrl}
                  href={member.facebookUrl}
                  target={'_blank'}
                  rel={'noopener'}>
                  <Facebook/>
                </IconButton>

                <IconButton
                  classes={{ root: classes.iconButton + ' ' + classes.linkedInButton }}
                  disabled={!member.linkedInUrl}
                  href={member.linkedInUrl}
                  target={'_blank'}
                  rel={'noopener'}>
                  <LinkedIn/>
                </IconButton>

                <IconButton
                  classes={{ root: classes.iconButton + ' ' + classes.twitterButton }}
                  disabled={!member.twitterUrl}
                  href={member.twitterUrl}
                  target={'_blank'}
                  rel={'noopener'}>
                  <Twitter/>
                </IconButton>
              </div>
            </Grid>)
          }

        </Grid>
      </CardContent>
    </Card>
  );
};

export default withStyles(styles) (GroupLeadersView);
